import { render, staticRenderFns } from "./Wp_jd_skuinfo_poster.vue?vue&type=template&id=2991899c&scoped=true&"
import script from "./Wp_jd_skuinfo_poster.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_skuinfo_poster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991899c",
  null
  
)

export default component.exports